import * as React from "react";
import { Route } from "react-router-dom";
import { DiarySessionList } from "./List/DiarySessionList";
import { DiaryResults } from "./Results/DiaryResults";

export const DiaryRoot = () => {
    return (
        <>
            <Route exact path="/Diary" component={DiarySessionList} />
            <Route path="/Diary/Results/:id" component={DiaryResults} />
        </>
        );
}
